import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as sblLoginActions from '../../actions/sblLoginActions';
import Cookies from 'universal-cookie';
import {Link} from "react-router-dom";
import InnerHTML from 'dangerously-set-html-content'

const cookies = new Cookies();

class SblLanding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
        };
    }

    async componentDidMount() {
        this.setState({
            isReady: false
        })

        //cookies.set('session_id', 'f209c87f-290b-4607-8ac6-5dd9a459e5ea');

        //clear state
        this.setState({sbl_login_response: null});

        console.log('SESSION COOKIE: ' + cookies.get('session_id'));
        if (typeof cookies.get('session_id') === 'undefined') {
            console.log('session id cookie is not set.')
            window.location.href = window.CONFIG.fidelity_login_url;
            //window.location.href = 'https://retailssodxq1.fidelity.com/ftgw/ssodirector/Start?SSOVendorID=LDRBK&Role=LendingApplicant&Target=home&ContentID=Default&inChildWindow=N&ShowDisclaimer=N';
        } else {
            console.log('session id cookie is set.');
            this.setState({session_id: cookies.get('session_id')})
            await this.props.actions.getSblLogin(cookies.get('session_id'));
            console.log(localStorage.getItem('sbl-login-response'));
            //alert(localStorage.getItem('sbl-login-response'));
            this.setState({sbl_login_response: localStorage.getItem('sbl-login-response')});
        }
        this.setState({
            isReady: true
        })
    }

    handleChange(e) {
        let name = e.target.value
        this.setState({
            name
        })
    }


    render() {
        // let sblLoginResponse = localStorage.getItem('sbl-login-response');
        let sblLoginResponse = this.state.sbl_login_response;
        let isReady = this.state.isReady;
        let autoSubmitScript = `<script>
                          document.forms[0].submit();
                     </script>`
        return (
            <div>
                {isReady ?
                    sblLoginResponse && sblLoginResponse != "null" ?
                    <InnerHTML html={sblLoginResponse + autoSubmitScript} />:
                    <InnerHTML html={`<script>
                        window.location.href = window.CONFIG.fidelity_login_url;
                        //window.location.href = 'https://retailssodxq1.fidelity.com/ftgw/ssodirector/Start?SSOVendorID=LDRBK&Role=LendingApplicant&Target=home&ContentID=Default&inChildWindow=N&ShowDisclaimer=N';
                    </script>`} />: null
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    console.log('mapStateToProps: state: ' + JSON.stringify(state));
    return {sbl_login_response: state.sbl_login_response};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(sblLoginActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SblLanding);




// WEBPACK FOOTER //
// ./src/containers/sbl-landing/sbl-landing.js